import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "initial-page",
  "dark-class": "initial-dark-page"
}
const _hoisted_2 = { class: "steer-box" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "title t-c" }, "设置向导", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "prompt t-c" }, "跟着设置向导完善基础设置吧！", -1)
const _hoisted_5 = { class: "number-box" }
const _hoisted_6 = { class: "index" }
const _hoisted_7 = { class: "info-box" }
const _hoisted_8 = { class: "name" }
const _hoisted_9 = { class: "form-box" }
const _hoisted_10 = { class: "button-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_elem_icon = _resolveComponent("elem-icon")!
  const _component_comp_form_small = _resolveComponent("comp-form-small")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "close-box",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onCloseStep && _ctx.onCloseStep(...args)))
    }, [
      _createVNode(_component_elem_icon, { name: "close_white" })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.initials, (item, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["item-box", { activity: _ctx.step === idx, success: _ctx.step > idx }]),
            key: idx
          }, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(idx + 1), 1),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(item.title), 1)
            ])
          ], 2))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.initials, (item, idx) => {
          return _withDirectives((_openBlock(), _createBlock(_component_comp_form_small, {
            key: idx,
            ref_for: true,
            ref: item.name,
            structure: item.value
          }, null, 8, ["structure"])), [
            [_vShow, _ctx.step === idx]
          ])
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("button", {
          class: _normalizeClass(["button back", { disabled: _ctx.step === 0 }]),
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onBackStep && _ctx.onBackStep(...args)))
        }, [
          _createVNode(_component_elem_icon, {
            name: "back",
            width: "20px",
            height: "20px"
          })
        ], 2),
        _createElementVNode("button", {
          class: "button next",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onNextStep && _ctx.onNextStep(...args)))
        }, _toDisplayString(_ctx.step === _ctx.initials?.length - 1 ? "提交" : "下一步"), 1)
      ])
    ])
  ]))
}